import { NSP_INCOGNITO_DATA } from 'app/consts'

export const KEY_REDUCER_INCOGNITO = 'incognitoDataReducer'
export const UPDATE_TOTAL_BALANCE = `${NSP_INCOGNITO_DATA}UPDATE_TOTAL_BALANCE`
export const UPDATE_AVAILABLE_BALANCE = `${NSP_INCOGNITO_DATA}UPDATE_AVAILABLE_BALANCE`
export const INCOGNITO_GET_PRIVACY_TOKENS = `${NSP_INCOGNITO_DATA}INCOGNITO_GET_PRIVACY_TOKENS`
export const INCOGNITO_GET_PCUSTOM_TOKEN = `${NSP_INCOGNITO_DATA}INCOGNITO_GET_PCUSTOM_TOKEN`
export const INCOGNITO_GET_PCUSTOM_TOKEN_SUCCEEDED = `${NSP_INCOGNITO_DATA}INCOGNITO_GET_PCUSTOM_TOKEN_SUCCEEDED `
export const INCOGNITO_GET_PCUSTOM_TOKEN_FAILED = `${NSP_INCOGNITO_DATA}INCOGNITO_GET_PCUSTOM_TOKEN_FAILED`
export const INCOGNITO_GET_ACCOUNTS = `${NSP_INCOGNITO_DATA}INCOGNITO_GET_ACCOUNTS`
export const INCOGNITO_GET_ACCOUNTS_SUCCEEDED = `${NSP_INCOGNITO_DATA}INCOGNITO_GET_ACCOUNTS_SUCCEEDED`
export const INCOGNITO_ACCOUNT_SELECTED = `${NSP_INCOGNITO_DATA}INCOGNITO_ACCOUNT_SELECTED`
export const INCOGNITO_CREATE_ACCOUNT = `${NSP_INCOGNITO_DATA}INCOGNITO_CREATE_ACCOUNT`
export const INCOGNITO_REMOVE_ACCOUNT = `${NSP_INCOGNITO_DATA}INCOGNITO_REMOVE_ACCOUNT`
export const INCOGNITO_REMOVE_ERROR = `${NSP_INCOGNITO_DATA}INCOGNITO_PRIVACY_TOKEN_SELECTED`
export const INCOGNITO_PRIVACY_TOKEN_SELECTED = `${NSP_INCOGNITO_DATA}INCOGNITO_REMOVE_ERROR`

export const FIELDS_STATE = {
  ACCOUNTS: 'ACCOUNTS',
  ACCOUNT_SELECTED: 'ACCOUNT_SELECTED',
  INCOGNITO_ERROR: 'INCOGNITO_ERROR',
  INCOGNITO_LOADING: 'INCOGNITO_LOADING',
  INCOGNITO_PCUSTOM_TOKENS: 'INCOGNITO_PCUSTOM_TOKENS',
  INCOGNITO_PCUSTOM_TOKEN_ERROR: 'INCOGNITO_PCUSTOM_TOKEN_ERROR',
  INCOGNITO_PRIVACY_TOKENS: 'INCOGNITO_PRIVACY_TOKENS',
  INCOGNITO_PRIVACY_TOKEN_SELECTED: 'INCOGNITO_PRIVACY_TOKEN_SELECTED',
}
